import type { CalendarEvent } from './calendars'

/**
 * Rang d'un evenement dans sa journee, le plus petit devant : ce que
 * l'utilisateur a note lui-meme, puis d'un calendrier lie ce qui le concerne
 * (convoque), ce qui le concernera sans doute (attendu), et le reste.
 */
export const lowestRank = 3

export function eventRank(event: CalendarEvent, linked: boolean): number {
  if (!linked) {
    return 0
  }

  switch (event.participation) {
    case 'expected':
      return 2
    case 'other':
      return lowestRank
    default:
      // Convoque, ou pas encore classe : montre comme avant.
      return 1
  }
}

const byTime = (left: CalendarEvent, right: CalendarEvent) =>
  Number(right.isAllDay) - Number(left.isAllDay) || left.startsAt.localeCompare(right.startsAt)

/**
 * Evenements d'une journee, dans l'ordre ou les montrer, et combien restent
 * derriere le « + ».
 *
 * Sans limite (semaine), tout est montre dans l'ordre des heures : le rang ne
 * departage que les evenements simultanes. Avec une limite (mois), le rang
 * passe d'abord, et si tout ne tient pas, ce qui ne concerne pas
 * l'utilisateur ne prend la place de rien : il est derriere le « + ».
 */
export function layoutDay(
  events: CalendarEvent[],
  rank: (event: CalendarEvent) => number,
  limit: number | null,
): { shown: CalendarEvent[]; more: number } {
  if (limit === null) {
    return { shown: [...events].sort((left, right) => byTime(left, right) || rank(left) - rank(right)), more: 0 }
  }

  const sorted = [...events].sort((left, right) => rank(left) - rank(right) || byTime(left, right))
  if (sorted.length <= limit) {
    return { shown: sorted, more: 0 }
  }

  const shown = sorted.filter((event) => rank(event) < lowestRank).slice(0, limit)
  return { shown, more: sorted.length - shown.length }
}
